<script setup>
import { Handle, Position } from '@vue-flow/core'

const props = defineProps({
    id: String,
    data: Object,
})
</script>

<template>
    <div class="workflow-node workflow-node--trigger">
        <div class="workflow-node__type">TRIGGER</div>
        <div class="workflow-node__title">{{ data?.config?.trigger_type || 'Not configured' }}</div>
        <Handle type="source" :position="Position.Bottom" />
    </div>
</template>
